import cx from "classnames";

import useFocusOnModalEnter from "hooks/useFocusOnModalEnter";

import styles from "./styles.module.css";
import Box, { BoxProps } from "../Box";

type ModalContentProps = BoxProps & { shouldFocusOnEnter?: boolean };

const ModalContent = ({
  children,
  className,
  padding = "x-large",
  direction = "column",
  shouldFocusOnEnter,
  ...restProps
}: ModalContentProps) => {
  const bodyRef = useFocusOnModalEnter({
    shouldFocusOnEnter,
  });

  return (
    <Box
      ref={bodyRef}
      direction={direction}
      padding={padding}
      className={cx(styles.content, className)}
      fullWidth
      {...restProps}
    >
      {children}
    </Box>
  );
};

ModalContent.displayName = "DS.Modal.Content";

export default ModalContent;
